export const getReviewStyles = (colors, score) => ({
  container: {
    position: 'relative',
    minHeight: '100vh',
    background: colors.backgroundAccent,
    color: colors.text,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '96px 16px 88px',
    boxSizing: 'border-box',
  },
  groupSelector: {
    position: 'absolute',
    top: '80px',
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: 1,
    backgroundColor: colors.surface,
    padding: '8px',
    borderRadius: '14px',
    boxShadow: colors.shadow,
    border: `1px solid ${colors.border}`,
    minWidth: '200px',
  },
  select: {
    width: '100%',
    padding: '8px',
    border: `1px solid ${colors.border}`,
    borderRadius: '10px',
    fontSize: '14px',
    backgroundColor: colors.surfaceElevated,
    color: colors.text,
  },
  scoreContainer: {
    position: 'fixed',
    top: '16px',
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    backgroundColor: colors.surface,
    padding: '10px 16px',
    borderRadius: '22px',
    boxShadow: colors.shadow,
    zIndex: 1000,
    backdropFilter: 'blur(5px)',
    whiteSpace: 'nowrap',
    maxWidth: 'calc(100vw - 32px)',
  },
  challengeBanner: {
    position: 'fixed',
    top: '76px',
    left: '50%',
    transform: 'translateX(-50%)',
    backgroundColor: colors.surface,
    color: colors.text,
    borderRadius: '18px',
    padding: '10px 14px',
    boxShadow: colors.shadow,
    zIndex: 999,
    maxWidth: 'calc(100vw - 32px)',
    textAlign: 'center',
  },
  challengeTitle: {
    margin: 0,
    fontSize: '15px',
    fontWeight: '700',
  },
  challengeMeta: {
    margin: '4px 0 0',
    fontSize: '12px',
    opacity: 0.72,
  },
  score: {
    fontSize: '22px',
    fontWeight: '700',
    color: score.total >= 0 ? colors.positiveScore : colors.negativeScore,
    minWidth: '36px',
    textAlign: 'center',
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',
  },
  scoreDetailsContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '8px',
  },
  scoreDetail: {
    fontSize: '13px',
    display: 'flex',
    alignItems: 'center',
    gap: '3px',
    whiteSpace: 'nowrap',
    color: colors.text,
    fontWeight: '600',
  },
  separator: {
    opacity: 0.45,
    margin: '0 1px',
  },
  progressDetail: {
    fontSize: '11px',
    color: colors.text,
    opacity: 0.72,
    whiteSpace: 'nowrap',
  },
  timerDetail: {
    fontSize: '11px',
    color: colors.text,
    opacity: 0.72,
    whiteSpace: 'nowrap',
  },
  checkMark: {
    color: colors.positiveScore,
    fontWeight: '700',
    fontSize: '15px',
  },
  wrongMark: {
    color: colors.negativeScore,
    fontWeight: '700',
    fontSize: '15px',
  },
  emptyState: {
    maxWidth: '420px',
    width: '100%',
    textAlign: 'center',
    backgroundColor: colors.surface,
    color: colors.text,
    padding: '28px 24px',
    borderRadius: '24px',
    boxShadow: colors.shadow,
    border: `1px solid ${colors.border}`,
  },
  emptyTitle: {
    margin: '0 0 12px',
    fontSize: '24px',
    lineHeight: 1.2,
  },
  emptyText: {
    margin: '0 0 20px',
    fontSize: '15px',
    lineHeight: 1.5,
    opacity: 0.85,
    color: colors.textMuted,
  },
  emptyButton: {
    border: 'none',
    borderRadius: '999px',
    backgroundColor: colors.accent,
    color: colors.accentText,
    padding: '12px 18px',
    fontSize: '15px',
    fontWeight: '600',
    cursor: 'pointer',
  },
  toast: {
    position: 'fixed',
    bottom: '84px',
    left: '50%',
    transform: 'translateX(-50%)',
    backgroundColor: colors.surface,
    color: colors.text,
    padding: '10px 14px',
    borderRadius: '999px',
    boxShadow: colors.shadow,
    fontSize: '13px',
    zIndex: 1002,
    maxWidth: 'calc(100vw - 32px)',
    textAlign: 'center',
  },
  controlButton: {
    position: 'fixed',
    width: '50px',
    height: '50px',
    borderRadius: '50%',
    backgroundColor: colors.accent,
    color: colors.accentText,
    border: 'none',
    fontSize: '24px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: colors.shadow,
    transition: 'transform 0.2s',
    zIndex: 1000,
    bottom: '20px',
    right: '20px',
  }
});
